import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { OfficeService } from '../../shared/_services/office.service';
import { BranchService } from '../../shared/_services/branch.service';
import { PortfolioService } from '../../shared/_services/portfolio.service';

import { CollectionManagementResult } from '../../shared/models/collectionManagementResult.model';
import { Branch, Office } from '../../shared/models/missingdata.model';
import { ReportsService } from '../../shared/_services/reports.service';
import { Report, Filter } from '../../shared/models/report.model';
import { generatereport } from '../../shared/models/generatereport.model';
import { PortfolioState } from '../../shared/models/portfolioState.model';
import { AuthenticationService } from '../../shared/_services/authentication.service';
import { User } from '../../shared/models/user.model';

import { NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

import { MyFormatter } from '../../shared/_services/dateformat.service';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css'],
  providers: [{ provide: NgbDateParserFormatter, useClass: MyFormatter }]
})
export class ReportsComponent implements OnInit {

  managementResultList: CollectionManagementResult[];
  portfolioStateList: PortfolioState[];
  reportList: Report[];
  filterList: Filter[];
  filterIdList: number[] = [];
  statesIdList: number[] = [];
  dropdownSettings = {};
  currentUser: User;

  reportForm: FormGroup;
  reportRequest: any;
  reportName: string;
  error: string;

  generateReportInfo: generatereport;

  dateFrom: NgbDateStruct;
  dateTo: NgbDateStruct;

  constructor(private formBuilder: FormBuilder,
    private officeService: OfficeService,
    private branchService: BranchService,
    private portfolioService: PortfolioService,
    private reportService: ReportsService,
    private authenticationService: AuthenticationService) {
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
  }

  get f() { return this.reportForm.controls; }

  ngOnInit() {
    this.generateReportInfo = new generatereport();

    // obtención lista de reportes por rol
    this.reportService.getReportByIdRole()
      .subscribe((reports: Report[]) => {
        this.reportList = reports
      },err => this.error = err);

    // obtención lista de estados de gestión
    this.portfolioService.getPortfolioState()
      .subscribe(res => {
        this.portfolioStateList = res;
      });

    // inicialización multiselect dropdown
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'idCollectionManagementResult',         
      textField: 'rResultName',
      selectAllText: 'Seleccionar todo',
      unSelectAllText: 'Eliminar selección',
      itemsShowLimit: 4,
      allowSearchFilter: true
    };

  }

  get isAdmin() {
    return this.currentUser && this.currentUser.fkUserRole === 1;
  }
  get isCoordinator() {
    return this.currentUser && this.currentUser.fkUserRole === 2;
  }
  get isAnalyst() {
    return this.currentUser && this.currentUser.fkUserRole === 3;
  }
  get isAssistant() {
    return this.currentUser && this.currentUser.fkUserRole === 4;
  }
  get isOfficeUser() {
    return this.currentUser && this.currentUser.fkUserRole === 5;
  }
  get isAgent() {
    return this.currentUser && this.currentUser.fkUserRole === 6;
  }
  get isManagement() {
    return this.currentUser && this.currentUser.fkUserRole === 7;
  }

  onReportSelect(idReport: number) {
    //console.log("change report: " + idReport);
    this.generateReportInfo = new generatereport();
    this.managementResultList = new Array<CollectionManagementResult>();
    this.generateReportInfo.idReport = idReport;

    this.filterIdList.length = 0;
    // obtención lista de estados de cartera
    this.portfolioService.getCollectionResult()
      .subscribe(res => {
        this.managementResultList = res;
        //console.log("refresh list: ");
        //console.log(this.managementResultList);
         
        if (idReport == 4 || idReport == 2 || idReport == 3) {
          this.managementResultList = this.managementResultList.filter(u => u.replicatesPortfolio == true);
          //console.log("filter list: ");
          //console.log(this.managementResultList);
        }
      });

    this.reportService.getFiltersByIdReport(idReport)
      .subscribe((res: Filter[]) => {
        this.filterList = res;
        this.reportName = this.reportList.find(u => u.idReport == idReport).reportName;
        for (let i = 0; i < res.length; i++) {
          this.filterIdList.push(res[i].idFilter);
        }
      }, err => {
          this.error = err;
          this.cleanError();
      });
  }

  applyRequired(idFilter: number) {
    return this.filterList.find(u => u.idFilter == idFilter).required;
  }

  arrayRemove(arr, value) {
    return arr.filter(function (ele) {
      return ele != value;
    });
  }


  onItemSelect($event: CollectionManagementResult) {
    this.statesIdList.push($event.idCollectionManagementResult);
  }

  onItemDeSelect($event: CollectionManagementResult) {
    this.statesIdList = this.arrayRemove(this.statesIdList, $event.idCollectionManagementResult);
  }

  onSelectAll($event: CollectionManagementResult[]) {
    for (let i = 0; i < $event.length; i++) {
      this.statesIdList[i] = $event[i].idCollectionManagementResult;
    }
  }

  onDeselectAll($event) {
    this.statesIdList = $event;
  }

  onDropdownClose() {
    this.generateReportInfo.statePortfolio = this.statesIdList;
  }

  onDateSelectFrom($event: NgbDateStruct) {
    let dateFrom: Date = new Date($event.year, $event.month - 1, $event.day);
    this.generateReportInfo.fromUploadFile = dateFrom;
  }

  onDateSelectTo($event) {
    let dateTo: Date = new Date($event.year, $event.month - 1, $event.day);
    this.generateReportInfo.toUploadFile = dateTo;
  }

  downloadReport() {
    //this.reportService.generateReport(this.generateReportInfo)
    //  .subscribe(res => console.log(res));
    this.reportService.generateReport(this.generateReportInfo)
      .subscribe((blob: Blob) => {
        this.createFile(blob, 'Reporte-' + this.reportName + '.xlsx');
      },
        error => {
          this.error = error;
          this.cleanError();
        });
  }

  createFile(blob: Blob, filename: string) {
    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, filename);
    }
    else {
      let link = document.createElement("a");
      if (link.download !== undefined) {
        let url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      else {
        //html5 download not supported
      }
    }
  }

  cleanError() {
    setTimeout(() => {
      this.error = "";
    }, 7000);
  }
}
